import { Box, Button, Paper, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";

/**
 * Component for displaying a single NAT Gateway with status and action buttons
 *
 * @param {Object} props Component props
 * @param {string} props.name Name of the NAT gateway
 * @param {boolean} props.isReady Whether the gateway is available
 * @param {boolean} props.disabled Whether operations are disabled for this gateway
 * @param {Function} props.onDelete Function to call when delete button is clicked
 * @param {Function} props.onCreate Function to call when create button is clicked
 * @returns {JSX.Element} The NAT gateway card element
 */
const NatGatewayCard = ({ name, isReady, disabled, onDelete, onCreate }) => {
  return (
    <Grid size={3}>
      <Paper sx={{ p: 4 }}>
        <Grid container display="flex" py="5px">
          <Grid size={6}>
            <Typography
              variant="h1"
              sx={{
                fontSize: "1.5rem",
                fontWeight: "bold",
                display: "inline-block",
              }}
            >
              {name}
            </Typography>
          </Grid>
          <Grid size={6} justifyContent={"flex-end"} display="flex">
            {isReady ? (
              <Button variant="outlined" color="inherit" disabled={disabled} onClick={onDelete}>
                Delete
              </Button>
            ) : (
              <Button variant="outlined" color="inherit" disabled={disabled} onClick={onCreate}>
                Create
              </Button>
            )}
          </Grid>
        </Grid>
        <Grid>
          <Box display="flex" pt="10px">
            <Typography variant="h1" sx={{ fontSize: "1rem" }}>
              {isReady ? "AVAILABLE" : "UNAVAILABLE"}
            </Typography>
          </Box>
        </Grid>
      </Paper>
    </Grid>
  );
};

export default NatGatewayCard;
